export function contourPoints(points, smooth=false) {
  if(!smooth || points.length<3) return points;
  // Quadratic curves through edge midpoints stay inside the control polygon bounds.
  return points.flatMap((p,i)=>{
    const a=points[(i+points.length-1)%points.length],b=points[(i+1)%points.length];
    const start=p.map((v,k)=>(v+a[k])/2),end=p.map((v,k)=>(v+b[k])/2);
    return Array.from({length:8},(_,j)=>{
      const t=j/8;
      return p.map((v,k)=>(1-t)**2*start[k]+2*t*(1-t)*v+t*t*end[k]);
    });
  });
}

export function cutPoints(cut) {
  if(!cut.shape) return contourPoints(cut.points,cut.smooth);
  const [x0,y0,x1,y1]=cut.rect;
  if(cut.shape==="rectangle") return [[x0,y0],[x1,y0],[x1,y1],[x0,y1]];
  return Array.from({length:64},(_,i)=>{
    const angle=2*Math.PI*i/64;
    return [(x0+x1)/2+(x1-x0)/2*Math.cos(angle),(y0+y1)/2+(y1-y0)/2*Math.sin(angle)];
  });
}

export function transformShape(rect,start,point,handle="move") {
  const [x0,y0,x1,y1]=rect;
  if(handle==="move") {
    const dx=Math.max(-x0,Math.min(1-x1,point[0]-start[0]));
    const dy=Math.max(-y0,Math.min(1-y1,point[1]-start[1]));
    return [x0+dx,y0+dy,x1+dx,y1+dy];
  }
  const next=[...rect],min=.002;
  if(handle.includes("w"))next[0]=Math.max(0,Math.min(x1-min,point[0]));
  if(handle.includes("e"))next[2]=Math.min(1,Math.max(x0+min,point[0]));
  if(handle.includes("n"))next[1]=Math.max(0,Math.min(y1-min,point[1]));
  if(handle.includes("s"))next[3]=Math.min(1,Math.max(y0+min,point[1]));
  return next;
}

export function validateContour(points) {
  if(points.length<3 || points.length>256 || points.some(p=>p.length!==2 || p.some(v=>!Number.isFinite(v)||v<0||v>1)))
    throw new Error("Legalább 3 pont szükséges a képen/rajzon belül.");
  const cross=(a,b,c)=>(b[0]-a[0])*(c[1]-a[1])-(b[1]-a[1])*(c[0]-a[0]);
  let area=0;
  points.forEach((a,i)=>{
    const b=points[(i+1)%points.length];
    if(Math.hypot(a[0]-b[0],a[1]-b[1])<1e-9) throw new Error("Két kontúrpont nem eshet egybe.");
    area+=a[0]*b[1]-b[0]*a[1];
    for(let j=i+1;j<points.length;j++) {
      if(j===i+1 || (i===0&&j===points.length-1))continue;
      const c=points[j],d=points[(j+1)%points.length];
      if(Math.max(a[0],b[0])>=Math.min(c[0],d[0]) && Math.max(c[0],d[0])>=Math.min(a[0],b[0]) &&
         Math.max(a[1],b[1])>=Math.min(c[1],d[1]) && Math.max(c[1],d[1])>=Math.min(a[1],b[1]) &&
         cross(a,b,c)*cross(a,b,d)<=0 && cross(c,d,a)*cross(c,d,b)<=0) throw new Error("A kontúr nem metszheti önmagát.");
    }
  });
  if(Math.abs(area)<1e-8) throw new Error("A kivágás területe túl kicsi.");
  return points;
}

export function dxfContour(points,scene) {
  return points.map(([x,y])=>[scene.min[0]+x*(scene.max[0]-scene.min[0]),scene.max[1]-y*(scene.max[1]-scene.min[1])]);
}

export async function cutImage(image,contours) {
  const canvas=document.createElement("canvas");
  canvas.width=image.naturalWidth;canvas.height=image.naturalHeight;
  const ctx=canvas.getContext("2d");
  if(!ctx) throw new Error("A képszerkesztő nem indítható.");
  ctx.drawImage(image,0,0);ctx.globalCompositeOperation="destination-out";
  contours.forEach(points=>{
    validateContour(points);ctx.beginPath();
    points.forEach(([x,y],i)=>ctx[i?"lineTo":"moveTo"](x*canvas.width,y*canvas.height));
    ctx.closePath();ctx.fill();
  });
  return new Promise((resolve,reject)=>canvas.toBlob(blob=>blob?resolve(blob):reject(new Error("A PNG mentése sikertelen.")),"image/png"));
}
